import {
  BookingStatus,
  enumBookingSortOption,
} from '@rematter/frontend-lib-api-client';
import { humanReadableDate } from '@rematter/ui-web';

import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';
import { getLocale } from '~/shared/utils/locale';

export type SelectableBooking = QueryHookResult<
  typeof useBookingsQuery
>[number];

export const useBookingsQuery = createQueryHook(
  'trade.bookingsList',
  (params: {
    ids?: string[];
    statuses?: BookingStatus[];
    searchTerm?: string;
  }) => ({
    bookings: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          status: params.statuses,
        },
        sorting: [enumBookingSortOption.CreatedAtDesc],
        pagination: {
          limit: 20,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        status: true,
        loadingPort: {
          name: true,
        },
        destinationPort: {
          name: true,
        },
        vesselDepartureDate: true,
        vesselArrivalDate: true,
      },
    },
  }),
  {
    select: (data) => data.bookings.entries ?? [],
  },
);

export const SelectBooking = createEntityComboBox.remotelySearched(
  'SelectBooking',
  useBookingsQuery,
  {
    formatLabel: (booking) =>
      `#${booking.documentNumber}${booking.loadingPort?.name ? ` ・ ${booking.loadingPort?.name}` : ''}`,
    formatSubLabel: (booking) =>
      [
        booking.vesselDepartureDate &&
          humanReadableDate(booking.vesselDepartureDate, {
            locale: getLocale(),
          }),
        booking.vesselArrivalDate &&
          humanReadableDate(booking.vesselArrivalDate, { locale: getLocale() }),
      ]
        .filter(Boolean)
        .join(' → '),
  },
);
